// One place for showing dollar amounts, so every screen reads $16,280.00 and not $16280.00.
// Accepts the numbers, numeric strings and Prisma decimals the API returns; anything that is
// not a finite number shows as zero rather than "NaN".

export type MoneyInput = number | string | null | undefined

const MONEY = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** "16,280.00": the number with separators and two decimals, no currency sign. */
export function formatMoney(value: MoneyInput): string {
  const n = typeof value === 'number' ? value : Number(value)
  return MONEY.format(Number.isFinite(n) ? n : 0)
}

/** "$16,280.00" ("-$16,280.00" for a negative amount). */
export function formatCurrency(value: MoneyInput): string {
  const text = formatMoney(value)
  return text.startsWith('-') ? `-$${text.slice(1)}` : `$${text}`
}
